/* eslint-disable react-refresh/only-export-components */
import '@fontsource-variable/manrope'
import '@fontsource-variable/newsreader'
import '@xyflow/react/dist/style.css'
import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Route, Router, Switch } from 'wouter'
import { AppShell } from './components/AppShell'
import { AnalyticsTracker } from './components/AnalyticsTracker'
import { SessionBootstrap } from './components/SessionBootstrap'
import { I18nProvider, useI18n } from './i18n'
import './styles.css'
import { LandingPage } from './pages/LandingPage'
import { NotFoundPage } from './pages/NotFoundPage'

const ChatPage = lazy(() => import('./pages/ChatPage').then((module) => ({ default: module.ChatPage })))
const GraphPage = lazy(() => import('./pages/GraphPage').then((module) => ({ default: module.GraphPage })))
const EvaluationPage = lazy(() => import('./pages/EvaluationPage').then((module) => ({ default: module.EvaluationPage })))
const OperationsPage = lazy(() => import('./pages/OperationsPage').then((module) => ({ default: module.OperationsPage })))
const AdminPage = lazy(() => import('./pages/AdminPage').then((module) => ({ default: module.AdminPage })))
const HumanApiPage = lazy(() => import('./pages/HumanApiPage').then((module) => ({ default: module.HumanApiPage })))
const AccountPage = lazy(() => import('./pages/AccountPage').then((module) => ({ default: module.AccountPage })))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage').then((module) => ({ default: module.PrivacyPage })))
const ContactPage = lazy(() => import('./pages/ContactPage').then((module) => ({ default: module.ContactPage })))
const ResumePage = lazy(() => import('./pages/ResumePage').then((module) => ({ default: module.ResumePage })))

function LoadingFallback() {
  const { t } = useI18n()
  return <div className="grid min-h-[calc(100vh-72px)] place-items-center"><span className="text-xs text-ink/40">{t('loading.connecting')}</span></div>
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <SessionBootstrap>
        <Router>
          <AnalyticsTracker />
          <AppShell>
            <Suspense fallback={<LoadingFallback />}>
            <Switch>
              <Route path="/" component={LandingPage} />
              <Route path="/chat" component={ChatPage} />
              <Route path="/graph" component={GraphPage} />
              <Route path="/evaluation" component={EvaluationPage} />
              <Route path="/operations" component={OperationsPage} />
              <Route path="/admin" component={AdminPage} />
              <Route path="/human-api" component={HumanApiPage} />
              <Route path="/account" component={AccountPage} />
              <Route path="/privacy" component={PrivacyPage} />
              <Route path="/contact" component={ContactPage} />
              <Route path="/resume" component={ResumePage} />
              <Route component={NotFoundPage} />
            </Switch>
            </Suspense>
          </AppShell>
        </Router>
      </SessionBootstrap>
    </I18nProvider>
  </StrictMode>,
)
